import { useMutation } from '@tanstack/react-query'

import { ReactQueryHttpError } from '@sparkai/shared-types'

import { apiClient } from '../apiClient'

type AvailableTasksResponse = {
  availableTasks: boolean
}

export function useMyAvailableTasks(
  onSuccess: (data: AvailableTasksResponse) => void,
  onError: (err: ReactQueryHttpError) => void
) {
  return useMutation<AvailableTasksResponse>({
    mutationFn: async () => {
      const { data } = await apiClient.get<AvailableTasksResponse>(`/int/v3/dispatcher/my-available-tasks`)
      return data
    },
    onSuccess,
    onError,
  })
}
